function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 4H16C18.2091 4 20 5.79086 20 8V16C20 18.2091 18.2091 20 16 20H8C5.79086 20 4 18.2091 4 16V8C4 5.79086 5.79086 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2H16C19.3137 2 22 4.68629 22 8V16C22 19.3137 19.3137 22 16 22H8C4.68629 22 2 19.3137 2 16V8ZM16.2857 7C15.8571 7 15.5714 7.28571 15.5714 7.71429V10.2857C15.5714 10.838 15.1237 11.2857 14.5714 11.2857H12.7143V7.71429C12.7143 7.28571 12.4286 7 12 7C11.5714 7 11.2857 7.28571 11.2857 7.71429V11.2857H8.42857V7.71429C8.42857 7.28571 8.14286 7 7.71429 7C7.28571 7 7 7.28571 7 7.71429V16.2857C7 16.7143 7.28571 17 7.71429 17C8.14286 17 8.42857 16.7143 8.42857 16.2857V12.7143H11.2857V16.2857C11.2857 16.7143 11.5714 17 12 17C12.4286 17 12.7143 16.7143 12.7143 16.2857V12.7143H14.8C16.015 12.7143 17 11.7295 17 10.5145V7.71429C17 7.28571 16.7143 7 16.2857 7ZM17 16.3332C17 16.7014 16.7015 16.9999 16.3333 16.9999C15.9651 16.9999 15.6667 16.7014 15.6667 16.3332C15.6667 15.965 15.9651 15.6665 16.3333 15.6665C16.7015 15.6665 17 15.965 17 16.3332Z",
  fill: "current"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/caja.6129b56a.svg";
export { SvgComponent as ReactComponent };